import DocumentsTypesVariablesModalView from "./documentsTypesVariablesModal.html";

angular.module("documents_types")

    .controller('DocumentsTypesEditCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', 'LoginService', '$stateParams', '$state', '$q', '$uibModal',
        function ($rootScope, $scope, Restangular, gridService, modalService, $filter, LoginService, $stateParams, $state, $q, $uibModal) {

            $scope.document_type = {};
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('documents_types.subtitleList'), url: "documents_types.list" },
                    { title: $filter('translate')('documents_types.button_add') }
                ];
            }
            else {
                Restangular.one('DocumentsTypes', $stateParams.id).get().then(function (results) {
                    $scope.document_type = results;

                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('documents_types.subtitleList'), url: "documents_types.list" },
                        { title: $scope.document_type.name + " - " + $filter('translate')('general.edit') }
                    ];


                }, function (response) {
                    $scope.errorMessage = response.message;
                });
            }

            $scope.cancel = function () {
                $state.go("documents_types.list", { "reset": false });
            };

            $scope.gridOptionsVariables = {
                pdfTitle: $filter('translate')('materials.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                //gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'name', displayName: $filter('translate')('documents_types.name'), enableFiltering: true },
                    { name: 'code', displayName: $filter('translate')('documents_types.code'), enableFiltering: true },
                    { name: 'format', displayName: $filter('translate')('documents_types.format'), enableFiltering: true },
                    { name: 'order', displayName: $filter('translate')('documents_types.order'), enableFiltering: true },
                    { name: 'show_by_default', displayName: $filter('translate')('type_variable.by_default'), enableFiltering: true, cellTemplate: '<i ng-if="row.entity.show_by_default > 0" class="fa fa-circle" style="color:green"></i><i ng-if="row.entity.show_by_default == 0" class="fa fa-circle" style="color:gray"></i>' },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.edit'), action: 'ng-click="grid.appScope.addDocumentTypeVariable(row.entity)"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteVariablesDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },

                ],
                getData: function (options) {
                    var deferred = $q.defer();
                    Restangular.all("DocumentsTypes").customGET("GetVariables", { document_type_id: $scope.document_type.id }).then(function (results) {
                        var data = results;
                        data.totalRows = results.length;
                        $scope.totalRows = data.totalRows;
                        deferred.resolve(data);
                    });

                    return deferred.promise;
                    
                }
            };


            $scope.save = function () {
                if (angular.isUndefined($stateParams.id) || $stateParams.id === "")
                    Restangular.all('DocumentsTypes').post($scope.document_type).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('documents_types.create_success'));
                            $scope.document_type.id = result.id;
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                else {
                    $scope.document_type.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('documents_types.edit_success'));
                            $state.go("documents_types.edit");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            };

            $scope.addDocumentTypeVariable = function (rowEntity) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: DocumentsTypesVariablesModalView,
                    size: "lg",
                    controller: "DocumentsTypesVariablesModalCtrl",
                    scope: $scope,
                    resolve: {
                        document_type_variable_id: function () {
                            return rowEntity ? rowEntity.id: null;
                        },
                        document_type_id: function () {
                            return $scope.document_type.id;
                        }
                    }
                });

                $modalInstance.result.then(function (success) {
                    $scope.gridOptionsVariables.loadData(false);
                });
            }


            $scope.delete = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('general.delete'),
                    message: $filter('translate')('general.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('DocumentsTypes', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('documents_types.delete_success'));
                            $state.go("documents_types.list", { "reset": false });
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

            $scope.goToEdit = function (rowEntity) {
                $scope.addDocumentTypeVariable(rowEntity);
            }


            $scope.deleteVariablesDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('general.delete'),
                    message: $filter('translate')('general.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('DocumentsTypesVariables', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('documents_types.delete_success'));
                            $scope.gridOptionsVariables.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };



    }]);